import { createTheme } from "@mui/material";
import { ruRU } from "@mui/material/locale";

export default createTheme(
  {
    spacing: 2,
    breakpoints: {
      values: {
        xs: 0,
        sm: 768,
        md: 1024,
        lg: 1440,
        xl: 1536,
      },
    },
    typography: {
      fontFamily: "Rubik, sans-serif",
    },
    components: {
      MuiButton: {
        defaultProps: {
          disableFocusRipple: true,
          disableRipple: true,
          disableElevation: true,
        },
        styleOverrides: {
          root: {
            textTransform: "none",
          },
        },
      },
      MuiTab: {
        defaultProps: {
          disableRipple: true,
          disableFocusRipple: true,
          disableTouchRipple: true,
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            left: "14px",
          },
        },
      },
      MuiCheckbox: {
        defaultProps: {
          disableRipple: true,
        },
        styleOverrides: {
          root: {
            padding: "0",
          },
        },
      },
      MuiRadio: {
        defaultProps: {
          disableRipple: true,
          disableTouchRipple: true,
        },
        styleOverrides: {
          root: {
            padding: "0",
            color: "grey.100",
            background: "transparent",
            "& ~ &": {
              background: "transparent",
            },
            "&:hover": {
              background: "transparent",
            },
          },
        },
      },
    },
    palette: {
      action: {
        disabledBackground: "#CBD5E0",
        disabled: "#FFFFFF",
      },
      info: {
        main: "#63B3ED",
      },
      primary: {
        main: "#1874FD",
        dark: "#085FE2",
      },
      grey: {
        100: "#718096", // inactive
        200: "#5B6473", // info
        300: "#2D3748", // headline
      },
      success: {
        main: "#2AD966",
      },
      warning: {
        main: "#FBD38D",
      },
      error: {
        main: "#F56565",
      },
    },
  },
  ruRU
);
